export default "__VITE_ASSET__B5Xi_3Mu__"